<template>
	<el-menu
		router
		mode="vertical"
		active-text-color="#1972FF"
		text-color="#08224D"
		:style="
			`
      width: ${styleData.containerWidth}px;height: ${styleData.mainHeight - 80}px;border-right: 0 solid #fff;
    `
		"
		class="elMenuVerticalDemo"
		:collapse="isCollapse"
		:default-openeds="styleData.openeds"
		:default-active="$route.path"
		menu-trigger="click"
	>
		<template v-for="item in menuList">
			<el-submenu
				v-if="item.children && item.children.length"
				:name="item.data && `/${item.data.systemTagName}${item.data.url}`"
				:index="item.data && `/${item.data.systemTagName}${item.data.url}`"
				:key="item.data && `/${item.data.systemTagName}${item.data.url}`"
			>
				<template slot="title">
					<i v-if="item.data && item.data.url && ICON[item.data.url]" :class="ICON[item.data.url].icon"></i>
					<span slot="title">{{ item.data && item.data.name }}</span>
				</template>
				<template v-for="el in item.children">
					<template v-if="el.children && el.children.length">
						<el-submenu
							:name="el.data && `/${el.data.systemTagName}${el.data.url}`"
							:key="el.data && `/${el.data.systemTagName}${el.data.url}`"
							:index="el.data && `/${el.data.systemTagName}${el.data.url}`"
						>
							<template slot="title">{{ el.data && el.data.name }}</template>
							<el-menu-item
								v-for="row in el.children"
								:key="row.data & `/${row.data.systemTagName}${row.data.url}`"
								:index="row.data && `/${row.data.systemTagName}${row.data.url}`"
							>
								{{ row.data && row.data.name }}
							</el-menu-item>
						</el-submenu>
					</template>
					<template v-else>
						<el-menu-item
							:name="el.data && `/${el.data.systemTagName}${el.data.url}`"
							:key="el.data && `/${el.data.systemTagName}${el.data.url}`"
							:index="el.data && `/${el.data.systemTagName}${el.data.url}`"
						>
							<span slot="title">{{ el.data && el.data.name }}</span>
						</el-menu-item>
					</template>
				</template>
			</el-submenu>
			<template v-else>
				<el-menu-item
					:index="item.data && `/${item.data.systemTagName}${item.data.url}`"
					:key="item.data && `/${item.data.systemTagName}${item.data.url}`"
				>
					<i v-if="item.data && item.data.url && ICON[item.data.url]" :class="ICON[item.data.url].icon"></i>
					<span slot="title" :title="item.data && item.data.name">{{ item.data && item.data.name }}</span>
				</el-menu-item>
			</template>
		</template>
	</el-menu>
</template>

<script>
import ICON from './../config/icon'
export default {
	name: 'Submenus',
	props: {
		menuList: {
			type: Array,
			default: () => [],
		},
		isCollapse: {
			type: Boolean,
			default: false,
		},
		styleData: {
			type: Object,
			default: {
				openeds: [],
				containerWidth: 160,
				mainHeight: 0,
				mainWidth: 0,
			},
		},
	},
	data() {
		return {
			ICON,
		}
	},
	computed: {
	},
	created() {
		if (localStorage.getItem('token')) {
      this.getFindRoleIds()
    }
	},
	mounted() {},
	methods: {
		getFindRoleIds () {
      this.$api.role.getFindRoleIds({}).then(res => {
        this.roleList = res.data || []
        localStorage.setItem('roleList', res.data)
        sessionStorage.setItem('roleList', res.data)
      })
    }
	},
}
</script>

<style lang="stylus" scoped>
/deep/ .el-aside .elMenuVerticalDemo {
  span{
    font-size 14px
  }
  .is-active{
    .el-submenu__title{
      background-color #E8F0FF !important
    }
  }
  .el-submenu__title{
    font-weight bold
  }
}
/deep/ .el-menu-item,
/deep/ .el-submenu__title {
  .iconfont{
    color #08224D
    margin-left -5px
  }
  span {
    margin-left 12px !important
  }
}
/deep/ .el-menu-item,
/deep/ .el-submenu .el-submenu__title {
  &:hover{
    color #1972FF !important
    .iconfont{
      color #1972FF !important
    }
  }
}

/deep/ .el-submenu .el-menu-item {
  height 40px !important
  line-height 40px !important
}
/deep/ .el-submenu__title {
  height 46px
  line-height 46px
  span {
    font-weight bold
  }
}
/deep/ .el-menu.el-menu--inline{
  &:hover{
    color #1972FF !important
    background-color #E8F0FF !important
  }
}
/deep/ .el-submenu.is-active .el-submenu__title,
/deep/ .el-menu-item.is-active {
  color #1972FF !important
  .iconfont{
    color #1972FF !important
  }
}
/deep/ .el-menu-item.is-active {
  background-color #ffffff !important
}
/deep/ .is-active{
  color #1972FF !important
  background-color #E8F0FF !important
}
/deep/ .el-menu-item {
  height 40px !important
  line-height 40px !important
}
/deep/ .el-menu-item {
  background-color #ffffff
  font-weight: bold;
  &:hover{
    background-color #E8F0FF !important
  }
}
/deep/.el-submenu{
    .el-menu{
        .el-menu-item{
            font-weight: 400;
        }
    }
}
</style>
